import styled, { css } from 'styled-components';

interface IButtonProps {
  svgWhiteBackground: boolean;
  svgRadius: boolean;
  disabled: boolean;
  backgroundColor: string | undefined;
  border: string | undefined;
  fullWidth: boolean;
  paddingButton: any;
}

export const Button = styled.button<IButtonProps>`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;

  font-weight: 700;
  font-size: 14px;
  color: ${({ color, theme }) => color ?? theme.colors.gray[100]};

  border-radius: 8px;
  background-color: ${(props) => {
    if (props.disabled) return props.theme.colors.gray[500];
    if (!props.backgroundColor) return props.theme.colors.orange.primary;
    if (props.backgroundColor === 'blue')
      return props.theme.colors.blue.primary;
    return props.backgroundColor;
  }};
  border: ${(props) => props.border ?? 'none'};
  padding: 0 ${props => props.paddingButton}px;

  transition: 0.2s ease;

  height: 48px;
  width: ${({ fullWidth }) => fullWidth ? "100%" : "auto"};

  span {
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 700;
  }

  .arrow {
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 10px;
  }

  &:hover {
    filter: brightness(0.9);
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.gray[500]} !important;
    cursor: not-allowed;
  }

  svg {
    margin: 0 4px;
    ${(props) =>
      props.svgWhiteBackground &&
      css`
        color: ${({ theme }) =>
          !props.disabled
            ? theme.colors.orange.primary
            : theme.colors.gray[500]};
        background: ${({ theme }) => theme.colors.white};
      `}

    ${(props) =>
      props.svgRadius &&
      css`
        border-radius: 50%;
        padding: 1px;
      `}
  }
`;
